import {Component} from '@angular/core';
/**
 * \@title Dynamic grid-list
 */
export class GridListDynamicExample {
  tiles = [
    {text: 'One', cols: 3, rows: 1, color: 'lightblue'},
    {text: 'Two', cols: 1, rows: 2, color: 'lightgreen'},
    {text: 'Three', cols: 1, rows: 1, color: 'lightpink'},
    {text: 'Four', cols: 2, rows: 1, color: '#DDBDF1'},
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'grid-list-dynamic-example',
  templateUrl: 'grid-list-dynamic-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GridListDynamicExample_tsickle_Closure_declarations() {
/** @type {?} */
GridListDynamicExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GridListDynamicExample.ctorParameters;
/** @type {?} */
GridListDynamicExample.prototype.tiles;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
